import angular from "angular";
import {
  getResolveObjectFromGridConfiguration,
  GridConfiguration,
  vsComponentName as recordGridViewComponentName,
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../records/views/recordGridView";
import { StateParams, StateProvider, StateService } from "@uirouter/angularjs";
import { vsComponentName as FormViewComponentName } from "../records/forms/formView";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../records/grids/columns/columnDefinitionService";
import { IRowCommandEventArgs } from "../records/grids/controller";
import { IQService } from "angular";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../records/server/serverUtility";
import { Record } from "../records/server/crud";
import { IQueryResponse, ServiceResponse } from "../records/server/query";
import { vsComponentName as webJobsComponentName } from "./view/grid";
import { vsComponentName as WebJobDetailComponentName } from "./view/detail";
import {
  SelectRecordModalService,
  vsServiceName as SelectRecordModalServiceName,
} from "../records/services/selectRecordModal";

const baseState = "main.webJobs";

routeConfig.$inject = ["$stateProvider"];
export function routeConfig($stateProvider: StateProvider) {
  $stateProvider
    .state("main.webjobs", {
      url: "webjobs",
      template: "<ui-view></ui-view>",
      abstract: true,
    })
    .state("main.webjobs.grid", {
      url: "/grid",
      component: webJobsComponentName,
      resolve: {
        onAddNew: [
          "$state",
          SelectRecordModalServiceName,
          RecordGridViewServiceName,
          ColumnDefinitionServiceName,
          (
            $state: StateService,
            selectRecordModalService: SelectRecordModalService,
            recordGridViewService: RecordGridViewService,
            columnDefinitionService: ColumnDefinitionService
          ) => [
            () => {
              const gridConfiguration =
                recordGridViewService.getGridConfiguration("machine")!;
                gridConfiguration.showSelectButtons = true;
                if (!Array.isArray(gridConfiguration.columns)) {
                  gridConfiguration.columns = [];
                }
                const modal = selectRecordModalService.openModal({
                gridConfiguration,
                showDoneButton: true,
                
                onItemSelected: (item, modalInstance) => {
                  modalInstance.close(item);
                 
                  // modalInstance.result.then((item) =>
                  //   $state.go(".add", { machineId: item.MachineId })
                  // );
                },
                title: "Machines",
                onSubmitSelection: (selectedIds, modalInstance) => {
                  const payload = {
                    MessageId: "",
                    Status: "Pending",
                    JobType: "machine",
                    PayloadJson: JSON.stringify(
                      selectedIds.map((id) => ({ MachineId: id }))
                    ),
                  };
              
                  const injector = angular.element(document.body).injector();
                  const $http = injector.get("$http");
                  const $state = injector.get("$state");
              
                  $http.post("/api/webjobs", payload).then((r) => {
                    modalInstance.close(r);
                    //$state.go("main.webjobs.grid");
                  });
                },
              });

              return modal.result;
            },
          ],
        ],
      },
    })
    .state("main.webjobs.info", {
      url: "/{id:int}/info",
      component: WebJobDetailComponentName,
      resolve: {
        id: [
          "$stateParams",
          function ($stateParams: StateParams) {
            return $stateParams["id"];
          },
        ],
        webJobDetail: [
          ServerUtilityName,
          "id",
          function (serverUtility: ServerUtility, $id: number) {
            return serverUtility
              .getById({
                url: `api/webJobs`,
                id: $id,
              })
              .then((r: any) => r.Result);
          },
        ],
      },
    });
  }